import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const NoWincarddata = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <>
      <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
        <button className="win-back-btn me-3" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
        <h2 className="page-heading">
          {isHighmarkPortal ? t("ffbCardsTitle") : t("wincardsTitle")}
        </h2>
      </div>

      <div className="no-data-available text-center mt-5">
        {isHighmarkPortal ? t("noffwincarddata") : t("nowincarddata")}
      </div>
    </>
  );
};

export default NoWincarddata;
